/**
 * Generated by `pnpm generate:sdk-types` — DO NOT EDIT BY HAND.
 *
 * Flat catalog of the fonts the platform vendors to its CDN and injects
 * into every plugin iframe (see `useFiasFonts`). Sourced from
 * `@fias/platform-resources` at generation time and baked in so the SDK
 * keeps zero runtime dependencies — it ships inside plugin iframes and
 * must stay bundle-clean.
 *
 * `tests/architecture/sdk-generated-types-fresh.test.ts` fails CI if this
 * file drifts from the catalog.
 */

export type FontCategory = 'sans' | 'serif' | 'display' | 'mono' | 'handwriting' | 'system';

export interface FontCatalogEntry {
  /** CSS `font-family` name — use in styles and pass to `ensureFontLoaded`. */
  family: string;
  /** Human-readable label for font pickers. */
  displayName: string;
  category: FontCategory;
  /**
   * `true` for OS-resident fonts (Arial, Georgia, …): always available,
   * no `@font-face` is injected and `ensureFontLoaded` resolves instantly.
   */
  system: boolean;
}

/** Every platform font available to plugins, sorted by family name. */
export const FONT_CATALOG: readonly FontCatalogEntry[] = [
  { family: 'Abril Fatface', displayName: 'Abril Fatface', category: 'display', system: false },
  { family: 'Alfa Slab One', displayName: 'Alfa Slab One', category: 'display', system: false },
  { family: 'Anton', displayName: 'Anton', category: 'display', system: false },
  { family: 'Archivo Black', displayName: 'Archivo Black', category: 'display', system: false },
  { family: 'Arial', displayName: 'Arial', category: 'sans', system: true },
  { family: 'Assistant', displayName: 'Assistant', category: 'sans', system: false },
  {
    family: 'Atkinson Hyperlegible',
    displayName: 'Atkinson Hyperlegible',
    category: 'sans',
    system: false,
  },
  { family: 'Baloo 2', displayName: 'Baloo 2', category: 'display', system: false },
  { family: 'Bangers', displayName: 'Bangers', category: 'display', system: false },
  { family: 'Barlow', displayName: 'Barlow', category: 'sans', system: false },
  { family: 'Bebas Neue', displayName: 'Bebas Neue', category: 'display', system: false },
  { family: 'Bitter', displayName: 'Bitter', category: 'serif', system: false },
  { family: 'Bubblegum Sans', displayName: 'Bubblegum Sans', category: 'display', system: false },
  { family: 'Cabin', displayName: 'Cabin', category: 'sans', system: false },
  { family: 'Cardo', displayName: 'Cardo', category: 'serif', system: false },
  { family: 'Caveat', displayName: 'Caveat', category: 'handwriting', system: false },
  { family: 'Chewy', displayName: 'Chewy', category: 'display', system: false },
  { family: 'Cinzel', displayName: 'Cinzel', category: 'serif', system: false },
  { family: 'Comfortaa', displayName: 'Comfortaa', category: 'display', system: false },
  { family: 'Concert One', displayName: 'Concert One', category: 'display', system: false },
  {
    family: 'Cormorant Garamond',
    displayName: 'Cormorant Garamond',
    category: 'serif',
    system: false,
  },
  { family: 'Courier New', displayName: 'Courier New', category: 'mono', system: true },
  { family: 'Creepster', displayName: 'Creepster', category: 'display', system: false },
  { family: 'Crimson Pro', displayName: 'Crimson Pro', category: 'serif', system: false },
  {
    family: 'Dancing Script',
    displayName: 'Dancing Script',
    category: 'handwriting',
    system: false,
  },
  { family: 'DM Mono', displayName: 'DM Mono', category: 'mono', system: false },
  { family: 'DM Sans', displayName: 'DM Sans', category: 'sans', system: false },
  { family: 'EB Garamond', displayName: 'EB Garamond', category: 'serif', system: false },
  { family: 'Fira Code', displayName: 'Fira Code', category: 'mono', system: false },
  { family: 'Fragment Mono', displayName: 'Fragment Mono', category: 'mono', system: false },
  { family: 'Fredoka', displayName: 'Fredoka', category: 'display', system: false },
  { family: 'Georgia', displayName: 'Georgia', category: 'serif', system: true },
  { family: 'Great Vibes', displayName: 'Great Vibes', category: 'handwriting', system: false },
  { family: 'Helvetica', displayName: 'Helvetica', category: 'sans', system: true },
  { family: 'IBM Plex Mono', displayName: 'IBM Plex Mono', category: 'mono', system: false },
  { family: 'Inconsolata', displayName: 'Inconsolata', category: 'mono', system: false },
  { family: 'Indie Flower', displayName: 'Indie Flower', category: 'handwriting', system: false },
  { family: 'Inter', displayName: 'Inter', category: 'sans', system: false },
  { family: 'JetBrains Mono', displayName: 'JetBrains Mono', category: 'mono', system: false },
  { family: 'Kalam', displayName: 'Kalam', category: 'handwriting', system: false },
  { family: 'Karla', displayName: 'Karla', category: 'sans', system: false },
  { family: 'Lato', displayName: 'Lato', category: 'sans', system: false },
  { family: 'Lexend', displayName: 'Lexend', category: 'sans', system: false },
  {
    family: 'Libre Baskerville',
    displayName: 'Libre Baskerville',
    category: 'serif',
    system: false,
  },
  { family: 'Lilita One', displayName: 'Lilita One', category: 'display', system: false },
  { family: 'Lobster', displayName: 'Lobster', category: 'display', system: false },
  { family: 'Lora', displayName: 'Lora', category: 'serif', system: false },
  { family: 'Luckiest Guy', displayName: 'Luckiest Guy', category: 'display', system: false },
  { family: 'Manrope', displayName: 'Manrope', category: 'sans', system: false },
  { family: 'Merriweather', displayName: 'Merriweather', category: 'serif', system: false },
  { family: 'Montserrat', displayName: 'Montserrat', category: 'sans', system: false },
  { family: 'Mulish', displayName: 'Mulish', category: 'sans', system: false },
  { family: 'Nunito', displayName: 'Nunito', category: 'sans', system: false },
  { family: 'Nunito Sans', displayName: 'Nunito Sans', category: 'sans', system: false },
  { family: 'Open Sans', displayName: 'Open Sans', category: 'sans', system: false },
  { family: 'Oswald', displayName: 'Oswald', category: 'sans', system: false },
  { family: 'Outfit', displayName: 'Outfit', category: 'sans', system: false },
  { family: 'Pacifico', displayName: 'Pacifico', category: 'display', system: false },
  { family: 'Patrick Hand', displayName: 'Patrick Hand', category: 'handwriting', system: false },
  { family: 'Patua One', displayName: 'Patua One', category: 'display', system: false },
  {
    family: 'Permanent Marker',
    displayName: 'Permanent Marker',
    category: 'display',
    system: false,
  },
  { family: 'Playfair Display', displayName: 'Playfair Display', category: 'serif', system: false },
  {
    family: 'Plus Jakarta Sans',
    displayName: 'Plus Jakarta Sans',
    category: 'sans',
    system: false,
  },
  { family: 'Poppins', displayName: 'Poppins', category: 'sans', system: false },
  { family: 'PT Serif', displayName: 'PT Serif', category: 'serif', system: false },
  { family: 'Quicksand', displayName: 'Quicksand', category: 'sans', system: false },
  { family: 'Raleway', displayName: 'Raleway', category: 'sans', system: false },
  { family: 'Righteous', displayName: 'Righteous', category: 'display', system: false },
  { family: 'Roboto', displayName: 'Roboto', category: 'sans', system: false },
  { family: 'Roboto Mono', displayName: 'Roboto Mono', category: 'mono', system: false },
  { family: 'Rubik', displayName: 'Rubik', category: 'sans', system: false },
  { family: 'Russo One', displayName: 'Russo One', category: 'display', system: false },
  { family: 'Sacramento', displayName: 'Sacramento', category: 'handwriting', system: false },
  { family: 'Satisfy', displayName: 'Satisfy', category: 'handwriting', system: false },
  {
    family: 'Shadows Into Light',
    displayName: 'Shadows Into Light',
    category: 'handwriting',
    system: false,
  },
  { family: 'Sora', displayName: 'Sora', category: 'sans', system: false },
  { family: 'Source Code Pro', displayName: 'Source Code Pro', category: 'mono', system: false },
  { family: 'Source Sans 3', displayName: 'Source Sans 3', category: 'sans', system: false },
  { family: 'Source Serif 4', displayName: 'Source Serif 4', category: 'serif', system: false },
  { family: 'Space Grotesk', displayName: 'Space Grotesk', category: 'sans', system: false },
  { family: 'Space Mono', displayName: 'Space Mono', category: 'mono', system: false },
  { family: 'Spectral', displayName: 'Spectral', category: 'serif', system: false },
  { family: 'Times New Roman', displayName: 'Times New Roman', category: 'serif', system: true },
  { family: 'Titan One', displayName: 'Titan One', category: 'display', system: false },
  { family: 'Ubuntu Mono', displayName: 'Ubuntu Mono', category: 'mono', system: false },
  { family: 'Verdana', displayName: 'Verdana', category: 'sans', system: true },
  { family: 'Work Sans', displayName: 'Work Sans', category: 'sans', system: false },
] as const;
